import React from "react";
import { NavLink } from "react-router-dom";
import { Home, CodeXml, BookOpen } from "lucide-react";
import { ThemeToggle } from "./ui";

const navItems = [
  { name: "Home", link: "/", icon: Home },
  { name: "Projects", link: "/projects", icon: CodeXml },
  { name: "Blogs", link: "/blogs", icon: BookOpen },
];

export default function Header() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-5 z-50 flex justify-center"
    >
      <ul className="flex items-center gap-1 rounded-full border border-black/10 bg-white/70 p-1.5 shadow-[0_8px_30px_rgba(0,0,0,0.12)] backdrop-blur-md dark:border-white/10 dark:bg-neutral-900/70 dark:shadow-[0_8px_30px_rgba(0,0,0,0.45)]">
        {navItems.map(({ name, link, icon: Icon }) => (
          <li key={name}>
            <NavLink
              to={link}
              end={link === "/"}
              aria-label={name}
              title={name}
              className={({ isActive }) =>
                `flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 dark:focus-visible:ring-white/40 ${
                  isActive
                    ? "bg-black/10 text-neutral-900 dark:bg-white/10 dark:text-white"
                    : "text-neutral-600 hover:bg-black/5 hover:text-neutral-900 dark:text-neutral-400 dark:hover:bg-white/5 dark:hover:text-white"
                }`
              }
            >
              <Icon size={20} aria-hidden="true" />
            </NavLink>
          </li>
        ))}
        <li aria-hidden="true">
          <span className="mx-0.5 block h-5 w-px bg-black/10 dark:bg-white/10" />
        </li>
        <li>
          <ThemeToggle />
        </li>
      </ul>
    </nav>
  );
}
